import React  from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import AgeSelectComponent from 'components/_new/compositions/forms/AgeSelect/AgeSelect'

import s from './AgeSelect.scss'


const options = [
  'Under 16',
  '16 to 17',
  '18 to 24',
  '25 to 34',
  '35 to 44',
  '45 to 54',
  '55 to 64',
  '65 or over',
  'Prefer not to answer',
]

const AgeSelect = ({ className, field }) => (
  <div className={cx(s.container, className)}>
    <AgeSelectComponent
      className={s.ageSelect}
      field={field}
      options={options}
    />
  </div>
)

AgeSelect.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object.isRequired,
}


export default AgeSelect
